import { toast, ToastOptions } from "react-toastify";

enum NotificationType {
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
  WARNING = "WARNING",
}

const toastOptions: ToastOptions = {
  position: "bottom-center",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: false,
  progress: undefined,
  theme: "dark",
};

const TOAST_ID = "global-toast";

const typeMap: Record<NotificationType, ToastOptions["type"]> = {
  [NotificationType.SUCCESS]: "success",
  [NotificationType.ERROR]: "error",
  [NotificationType.WARNING]: "warning",
};

const _notify = (type: NotificationType, message: string) => {
  const trimmed = message?.trim();
  if (!trimmed) {
    return;
  }

  const toastType = typeMap[type] ?? "default";

  if (toast.isActive(TOAST_ID)) {
    toast.update(TOAST_ID, { render: trimmed, type: toastType });
  } else {
    toast(trimmed, { ...toastOptions, type: toastType, toastId: TOAST_ID });
  }
};

export { _notify, NotificationType };
